<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Teilnehmerverwaltung" style="width:1400px;overflow:auto">
            <h2>{{ $t('userMasterData.Header') }}</h2>
            <div id="Grid">
                <Grid ref="grid"
                      :style="{ height: '640px' }"
                      :data-items="gridDataComputed"
                      :edit-field="'inEdit'"
                      :sortable="true"
                      :sort="sort"
                      :pageable="pageable"
                      :take="take"
                      :skip="skip"
                      :total="total"
                      :loader="loader"
                      @itemchange="itemChange"
                      @datastatechange="dataStateChange"
                      :selected-field="selectedField"
                      @rowclick="onRowClicked"
                      :columns="columns">
                    <grid-toolbar>
                        <kbutton title="Neu" :theme-color="'primary'" @click="onInsert">
                            {{ $t('userMasterData.ButtonNew') }}
                        </kbutton>
                        <kbutton title="Bearbeiten" :theme-color="'primary'" @click="onEdit" v-bind:disabled="buttonDisabled">
                            {{ $t('userMasterData.ButtonEdit') }}
                        </kbutton>
                        <kbutton title="L�schen" :theme-color="'primary'" @click="onDelete" v-bind:disabled="buttonDisabled">
                            {{ $t('userMasterData.ButtonDelete') }}
                        </kbutton>
                    </grid-toolbar>
                    <grid-norecords>{{ $t('userMasterData.NotificationNoData') }}</grid-norecords>
                </Grid>
            </div>
        </div>
        <br />
        <k-dialog v-if="visibleDialog" :title="$t('userMasterData.UserDetails')" :closeIcon="false">
            <div class="k-form k-form-horizontal">
                <div class="k-form-field">
                    <label for="EMail" class="k-form-label">{{ $t('userMasterData.GridColumnHeaderEMail') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="email"
                                 :name="'EMail'"
                                 v-model="selectedBenutzer.EMail">
                        </k-input>
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Name" class="k-form-label">{{ $t('userMasterData.GridColumnHeaderName') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="text"
                                 :name="'Name'"
                                 v-model="selectedBenutzer.Name">
                        </k-input>
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Vorname" class="k-form-label">{{ $t('userMasterData.GridColumnHeaderFirstname') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="text"
                                 :name="'Vorname'"
                                 v-model="selectedBenutzer.Vorname">
                        </k-input>
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Passwort" class="k-form-label">{{ $t('userMasterData.GridColumnHeaderPW') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="password"
                                 :name="'Passwort'"
                                 :minlength="8"
                                 :maxlength="30"
                                 v-model="selectedBenutzer.Passwort">
                        </k-input>
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Adminbestaetigung" class="k-form-label">{{ $t('userMasterData.GridColumnHeaderAdminChecked') }}</label>
                    <div class="k-form-field-wrap">
                        <k-switch :on-label="$t('userMasterData.SwitchLabelOn')" :off-label="$t('userMasterData.SwitchLabelOff')" @change="onChangeAdminbestaetigung" :checked="checkedAdminbestaetigung" />
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="IstAdmin" class="k-form-label">IstAdmin</label>
                    <div class="k-form-field-wrap">
                        <k-switch :on-label="$t('userMasterData.SwitchLabelOn')" :off-label="$t('userMasterData.SwitchLabelOff')" @change="onChangeIstAdmin" :checked="checkedIstAdmin" />
                    </div>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Verein" class="k-form-label">{{ $t('userMasterData.GridColumnHeaderClubname') }}</label>
                    <combobox :style="{ width: '320px' }"
                              :data-items="comboData"
                              :text-field="'bezeichnung'"
                              :data-item-key="'prim'"
                              :value-field="'prim'"
                              :value-primitive="true"
                              :filterable="true"
                              @filterchange="filterChange"
                              @change="handleChange"
                              :value="selectedPrimCombo"
                              v-model="selectedBenutzer.RefVereine">
                    </combobox>
                </div>
                <br />
                <div class="k-form-field">
                    <label for="Bemerkung" class="k-form-label">{{ $t('userMasterData.GridColumnHeaderRemark') }}</label>
                    <div class="k-form-field-wrap">
                        <k-input :style="{ width: '230px' }"
                                 type="text"
                                 :name="'Bemerkung'"
                                 v-model="selectedBenutzer.Bemerkung">
                        </k-input>
                    </div>
                </div>
            </div>
            <br />
            <div id="Buttons">
                <kbutton @click="onSubmitClick" class="k-button">{{ $t('userMasterData.ButtonSave') }}</kbutton>&nbsp;&nbsp;&nbsp;
                <kbutton @click="onCancelClick" class="k-button">{{ $t('userMasterData.ButtonCancel') }}</kbutton>
            </div>
        </k-dialog>
        <k-dialog v-if="visibleDeleteDialog" :title="$t('userMasterData.NotificationDeleteTitle')" @close="toggleDeleteDialog">
            <p :style="{ margin: '25px', textAlign: 'center' }">{{ $t('userMasterData.NotificationDelete') }}</p>
            <dialog-actions-bar>
                <kbutton @click='onDeleteData'>{{ $t('userMasterData.ButtonOK') }}</kbutton>
                <kbutton @click='toggleDeleteDialog'>{{ $t('userMasterData.ButtonCancel') }}</kbutton>
            </dialog-actions-bar>
        </k-dialog>
        <NotificationGroup :style="{
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                'align-items': 'flex-start'
                }">
            <Fade :appear="success">
                <Notification v-if="success" :type="{ style: 'success', icon: true }">
                    <span>{{ $t('userMasterData.NotificationSave') }}</span>
                </Notification>
            </Fade>
            <Fade :appear="error">
                <Notification v-if="error" :type="{ style: 'error', icon: true }">
                    <span>{{ $t('userMasterData.NotificationError') }}</span>
                </Notification>
            </Fade>
        </NotificationGroup>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { ComboBox } from '@progress/kendo-vue-dropdowns';
    import { Input } from '@progress/kendo-vue-inputs';
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { Button } from "@progress/kendo-vue-buttons";
    import { toODataString } from "@progress/kendo-data-query";
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
    import { Switch } from "@progress/kendo-vue-inputs";
    import { filterBy } from '@progress/kendo-data-query';
    import CommandCell from "@/components/CommandCell.vue";
    import config from "@/appdata/config.json";
    import Benutzer from "../classes/objSDBenutzer";
    import axios from 'axios';
    import sha512 from 'crypto-js/sha512';

    export default {
        components: {
            'k-dialog': Dialog,
            'dialog-actions-bar': DialogActionsBar,
            'k-input': Input,
            Grid: Grid,
            "grid-toolbar": GridToolbar,
            "grid-norecords": GridNoRecords,
            "k-switch": Switch,
            'combobox': ComboBox,
            custom: CommandCell,
            kbutton: Button,
            Fade,
            Notification,
            NotificationGroup
        },
        data: function () {
            return {
                baseUrl: config[0].ServiceUrl + config[0].ServiceUrlPort + "/BenutzerManagement",
                init: { method: "GET", accept: "application/json", headers: {} },
                filter: null,
                sort: null,
                pageable: false,
                gridData: [],
                comboData: [],
                baseComboUrl: config[0].ServiceUrl + config[0].ServiceUrlPort + "/VereineAuswahlManagement",
                skip: 0,
                take: 10,
                total: 0,
                updatedData: [],
                editID: null,
                selectedField: "selected",
                selectedPrim: 0,
                selectedPrimCombo: 0,
                selectedBenutzer: null,
                visibleDialog: false,
                neuerBenutzer: false,
                patchurlBenutzer: '',
                posturlBenutzer: '',
                deleteurlBenutzer: '',
                columns: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "eMail", editable: false, width: 200, title: this.$t('userMasterData.GridColumnHeaderEMail') },
                    { field: "name", editable: false, width: 120, title: this.$t('userMasterData.GridColumnHeaderName') },
                    { field: "vorname", editable: false, width: 120, title: this.$t('userMasterData.GridColumnHeaderFirstname') },
                    { field: "passwort", editable: false, hidden: true, width: 100, title: this.$t('userMasterData.GridColumnHeaderPW') },
                    { field: "passwortGeandert", type: "date", format: "{0:dd.MM.yyyy}", editable: false, width: 160, title: this.$t('userMasterData.GridColumnHeaderPWChanged') },
                    { field: "adminbestaetigung", editable: false, width: 150, title: this.$t('userMasterData.GridColumnHeaderAdminChecked') },
                    { field: "istAdmin", editable: false, width: 100, title: this.$t('userMasterData.GridColumnHeaderIsAdmin') },
                    { field: "refVereine", hidden: true, editable: false, width: 300, title: "refVereine" },
                    { field: "vereine.name", editable: false, width: 250, title: this.$t('userMasterData.GridColumnHeaderClubname') },
                    { field: "bemerkung", editable: false, width: 300, title: this.$t('userMasterData.GridColumnHeaderRemark') },
                ],
                loader: false,
                success: false,
                error: false,
                visibleDeleteDialog: false,
                forceComputedUpdate: null,
                checkedIstAdmin: false,
                checkedAdminbestaetigung: false,
            };
        },
        computed: {
            buttonDisabled() {
                return this.selectedPrim === 0;
            },
            hasItemsInEdit() {
                return this.gridData.filter((p) => p.inEdit).length > 0;
            },
            dataState() {
                return {
                    sort: this.sort,
                    skip: this.skip,
                    take: this.take,
                };
            },
            gridDataComputed() {
                if (this.forceComputedUpdate === 'undefined' || this.forceComputedUpdate === null) {
                    return [];
                } else {
                    return this.gridData.map((item) => ({ prim: item.prim, eMail: item.eMail, name: item.name, vorname: item.vorname, passwort: item.passwort, passwortGeandert: item.passwortGeandert, adminbestaetigung: item.adminbestaetigung, istAdmin: item.istAdmin, refVereine: item.refVereine, vereine: item.vereine, bemerkung: item.bemerkung, selected: (item.prim === this.selectedPrim) }));
                }
            },
        },
        created: function () {
            this.getDataCombo();
            this.getData();
        },
        methods: {
            handleChange(event) {
                this.selectedPrimCombo = event.value;
                this.selectedBenutzer.RefVereine = this.selectedPrimCombo;
            },
            getDataCombo: function () {
                this.selectedPrim = null;
                this.comboData = [];
                const that = this;
                fetch(this.baseComboUrl, this.init)
                    .then((response) => response.json())
                    .then((json) => {
                        const data = json["data"];
                        that.comboData = data;
                    });
            },
            onChangeIstAdmin(e) {
                this.checkedIstAdmin = e.target.value;
                this.selectedBenutzer.IstAdmin = this.checkedIstAdmin;
            },
            onChangeAdminbestaetigung(e) {
                this.checkedAdminbestaetigung = e.target.value;
                this.selectedBenutzer.Adminbestaetigung = this.checkedAdminbestaetigung;
            },
            onDeleteData() {
                this.deleteBenutzer();
                this.neuerBenutzer = false;
                this.visibleDeleteDialog = !this.visibleDeleteDialog;
            },
            toggleDeleteDialog() {
                this.visibleDeleteDialog = !this.visibleDeleteDialog;
            },
            saveNeuerBenutzer() {
                const crypted = sha512(this.selectedBenutzer.Passwort).toString();
                const parameters = {
                    "eMail": this.selectedBenutzer.EMail,
                    "name": this.selectedBenutzer.Name,
                    "vorname": this.selectedBenutzer.Vorname,
                    "passwort": crypted,
                    "passwortGeandert": new Date(),
                    "adminbestaetigung": this.selectedBenutzer.Adminbestaetigung,
                    "istAdmin": this.selectedBenutzer.IstAdmin,
                    "refVereine": this.selectedBenutzer.RefVereine,
                    "bemerkung": this.selectedBenutzer.Bemerkung,
                };
                this.posturlBenutzer = config[0].ServiceUrl + config[0].ServiceUrlPort + "/BenutzerManagement"
                axios.post(this.posturlBenutzer, parameters)
                    .then((response) => {
                        console.log("----------> success", response);
                        this.showNotificationSuccess();
                        //Reload Grid1
                        this.getData();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationError();
                    });
            },
            saveBenutzer() {
                const crypted = sha512(this.selectedBenutzer.Passwort).toString();
                const parameters = {
                    "eMail": this.selectedBenutzer.EMail,
                    "name": this.selectedBenutzer.Name,
                    "vorname": this.selectedBenutzer.Vorname,
                    "passwort": crypted,
                    "passwortGeandert": new Date(),
                    "adminbestaetigung": this.selectedBenutzer.Adminbestaetigung,
                    "istAdmin": this.selectedBenutzer.IstAdmin,
                    "refVereine": this.selectedBenutzer.RefVereine,
                    "bemerkung": this.selectedBenutzer.Bemerkung,
                };
                this.patchurlBenutzer = config[0].ServiceUrl + config[0].ServiceUrlPort + "/BenutzerManagement?prim=" + this.selectedBenutzer.Prim
                axios.patch(this.patchurlBenutzer, parameters)
                    .then((response) => {
                        console.log("----------> success", response);
                        this.showNotificationSuccess();
                        //Reload Grid1
                        this.getData();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationError();
                    });
            },
            deleteBenutzer() {
                this.deleteurlBenutzer = config[0].ServiceUrl + config[0].ServiceUrlPort + "/BenutzerManagement?prim=" + this.selectedBenutzer.Prim
                axios.delete(this.deleteurlBenutzer)
                    .then((response) => {
                        console.log("----------> success", response);
                        this.showNotificationSuccess();
                        //Reload Grid1
                        this.getData();
                    })
                    .catch((error) => {
                        console.log("---------> error", error);
                        this.showNotificationError();
                    });
            },
            handleComboChange(event) {
                this.value = event.value;
            },
            onInsert() {
                this.selectedBenutzer = new Benutzer();
                this.visibleDialog = true;
                this.neuerBenutzer = true;
            },
            onEdit() {
                this.visibleDialog = true;
                this.neuerBenutzer = false;
            },
            onDelete() {
                this.visibleDeleteDialog = true;
            },
            onSubmitClick() {
                if (this.neuerBenutzer === false) {
                    this.saveBenutzer();
                } else {
                    this.saveNeuerBenutzer();
                }
                this.visibleDialog = false;
                this.neuerBenutzer = false;
                
            },
            onCancelClick() {
                this.visibleDialog = false;
                this.neuerBenutzer = false;
            },
            onRowClicked(event) {
                this.selectedPrim = event.dataItem.prim;
                this.selectedBenutzer = new Benutzer();
                this.selectedBenutzer.Prim = event.dataItem.prim;
                this.selectedBenutzer.EMail = event.dataItem.eMail;
                this.selectedBenutzer.Name = event.dataItem.name;
                this.selectedBenutzer.Vorname = event.dataItem.vorname;
                this.selectedBenutzer.Passwort = event.dataItem.passwort;
                this.selectedBenutzer.Adminbestaetigung = event.dataItem.adminbestaetigung;
                this.selectedBenutzer.IstAdmin = event.dataItem.istAdmin;
                this.selectedBenutzer.Bemerkung = event.dataItem.bemerkung;
                this.selectedBenutzer.RefVereine = event.dataItem.refVereine;
                this.checkedIstAdmin = event.dataItem.istAdmin;
                this.checkedAdminbestaetigung = event.dataItem.adminbestaetigung;
            },
            updateService(action = "", item) {
                const that = this;
                const idIfNeeded =
                    action === "DELETE" || action === "PUT" ? `(${item.prim})` : "";
                const url = this.baseUrl + idIfNeeded;
                const body =
                    action === "POST" || action === "PUT"
                        ? JSON.stringify({
                            ProductID: item.prim,
                            ProductName: item.bezeichnung
                        })
                        : {};
                fetch(url, {
                    method: action,
                    accept: "application/json",
                    headers: {
                        "Content-type": "application/json",
                    },
                    body: body,
                }).then((response) => {
                    if (response.ok) {
                        that.getData();
                    } else {
                        alert("request failed");
                    }
                });
            },
            itemChange: function (e) {
                if (e.dataItem.prim) {
                    let index = this.gridData.findIndex(
                        (p) => p.ProductID === e.dataItem.prim
                    );
                    let updated = Object.assign({}, this.gridData[index], {
                        [e.field]: e.value,
                    });
                    this.gridData.splice(index, 1, updated);
                } else {
                    e.dataItem[e.field] = e.value;
                }
            },
            insert() {
                const dataItem = { inEdit: true };
                this.gridData.splice(0, 0, dataItem);
            },
            edit: function (e) {
                let index = this.gridData.findIndex(
                    (p) => p.ProductID === e.dataItem.ProductID
                );
                let updated = Object.assign({}, this.gridData[index], { inEdit: true });
                this.gridData.splice(index, 1, updated);
            },
            save: function (e) {
                let index = this.gridData.findIndex(
                    (p) => p.ProductID === e.dataItem.ProductID
                );
                let item = this.gridData[index];
                this.updateService(item.ProductID ? "PUT" : "POST", item);
            },
            update(data, item, remove) {
                let updated;
                let index = data.findIndex(
                    (p) => item.ProductID && p.ProductID === item.ProductID
                );
                if (index >= 0) {
                    updated = Object.assign({}, item);
                    data[index] = updated;
                } else {
                    let id = 1;
                    this.updatedData.forEach((p) => {
                        if (p.ProductID) {
                            id = Math.max(p.ProductID + 1, id);
                        }
                    });
                    updated = Object.assign({}, item, { ProductID: id });
                    data.unshift(updated);
                    index = 0;
                }

                if (remove) {
                    data = data.splice(index, 1);
                }
                return data[index];
            },
            cancel(e) {
                if (e.dataItem.ProductID) {
                    let index = this.gridData.findIndex(
                        (p) => p.ProductID === e.dataItem.ProductID
                    );
                    let updateDataIndex = this.updatedData.findIndex(
                        (p) => p.ProductID === e.dataItem.ProductID
                    );
                    let updated = Object.assign(this.updatedData[updateDataIndex], {
                        inEdit: undefined,
                    });
                    this.gridData.splice(index, 1, updated);
                } else {
                    let index = this.gridData.findIndex(
                        (p) => JSON.stringify(e.dataItem) === JSON.stringify(p)
                    );

                    this.gridData.splice(index, 1);
                }
            },
            remove(e) {
                e.dataItem.inEdit = undefined;
                this.updateService("DELETE", e.dataItem);
            },
            cancelChanges() {
                this.getData();
            },
            getData: function (initial) {
                this.forceComputedUpdate = null;
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrl + "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        if (json.length !== 0) {
                            this.forceComputedUpdate = new Date().getTime();
                            that.total = total;
                            that.updatedData = [].concat(data);
                            that.gridData = data;
                            this.loader = false;
                        } else {
                            this.forceComputedUpdate = null;
                        }
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            createAppState: function (dataState) {
                this.take = dataState.take;
                this.skip = dataState.skip;
                this.filter = dataState.filter;
                this.sort = dataState.sort;
                this.getData();
            },
            dataStateChange: function (event) {
                this.createAppState(event.data);
            },
            filterChange(event) {
                this.comboData = this.filterData(event.filter);
            },
            filterData(filter) {
                const data = this.comboData.slice();
                return filterBy(data, filter);
            },
            showNotificationSuccess() {
                /*Meldung anzeigen*/
                this.success = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.success = false;
                }, 3000);
            },
            showNotificationError() {
                /*Meldung anzeigen*/
                this.error = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.error = false;
                }, 3000);
            }
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>